import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface MainContentProps {
  children: ReactNode;
  className?: string;
}

/**
 * MainContent Landmark Component
 * 
 * Provides the semantic <main> landmark for accessibility.
 * This fixes:
 * - "Document does not have a main landmark" (Lighthouse Accessibility)
 * - Skip link functionality (targets #main-content)
 * 
 * Usage: Wrap the main content of each page (excluding Header/Footer)
 */
export function MainContent({ children, className }: MainContentProps) {
  return (
    <main
      id="main-content"
      role="main"
      tabIndex={-1}
      className={cn("outline-none", className)}
    >
      {children}
    </main>
  );
}

export default MainContent;
